/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  InAppProductsUserControllerFindBundleQueryResponse,
  InAppProductsUserControllerFindBundlePathParams,
  InAppProductsUserControllerFindBundleQueryParams,
  InAppProductsUserControllerFindBundle401,
  InAppProductsUserControllerFindBundle404,
} from '../../types/InAppProductsUserControllerFindBundle.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { inAppProductsUserFindBundle } from '../../methods/inAppProductsUserFindBundle.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const inAppProductsUserFindBundleQueryKey = (
  platform: InAppProductsUserControllerFindBundlePathParams['platform'],
  params: InAppProductsUserControllerFindBundleQueryParams,
) =>
  [
    { url: '/api/user/in-app-products/bundle/:platform', params: { platform: platform } },
    ...(params ? [params] : []),
  ] as const;

export type InAppProductsUserFindBundleQueryKey = ReturnType<typeof inAppProductsUserFindBundleQueryKey>;

export function inAppProductsUserFindBundleQueryOptions(
  platform: InAppProductsUserControllerFindBundlePathParams['platform'],
  params: InAppProductsUserControllerFindBundleQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = inAppProductsUserFindBundleQueryKey(platform, params);
  return queryOptions<
    InAppProductsUserControllerFindBundleQueryResponse,
    ResponseErrorConfig<InAppProductsUserControllerFindBundle401 | InAppProductsUserControllerFindBundle404>,
    InAppProductsUserControllerFindBundleQueryResponse,
    typeof queryKey
  >({
    enabled: !!(platform && params),
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return inAppProductsUserFindBundle(platform, params, config);
    },
  });
}

/**
 * {@link /api/user/in-app-products/bundle/:platform}
 */
export function useInAppProductsUserFindBundle<
  TData = InAppProductsUserControllerFindBundleQueryResponse,
  TQueryData = InAppProductsUserControllerFindBundleQueryResponse,
  TQueryKey extends QueryKey = InAppProductsUserFindBundleQueryKey,
>(
  platform: InAppProductsUserControllerFindBundlePathParams['platform'],
  params: InAppProductsUserControllerFindBundleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        InAppProductsUserControllerFindBundleQueryResponse,
        ResponseErrorConfig<InAppProductsUserControllerFindBundle401 | InAppProductsUserControllerFindBundle404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? inAppProductsUserFindBundleQueryKey(platform, params);

  const query = useQuery(
    {
      ...inAppProductsUserFindBundleQueryOptions(platform, params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<InAppProductsUserControllerFindBundle401 | InAppProductsUserControllerFindBundle404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
